import { useLiveSessionStore } from "../../../stores/useLiveSessionStore";
import { LiveKit } from "./LiveKit/LiveKit";
import { NagwaRenderingEngine } from "./NagwaRenderingEngine/NagwaRenderingEngine";
import "./Whiteboard.scss";
interface whiteboardProps {
  width: number;
  // ...other existing
}
export const Whiteboard = (whiteboardProps: whiteboardProps) => {
  const isEngineLoaded = useLiveSessionStore((state) => state.isEngineLoaded);

  return (
    <div
      className="whiteboard-container"
      style={{ width: whiteboardProps.width }}
    >
      <NagwaRenderingEngine />
      {isEngineLoaded && <LiveKit />}
    </div>
  );
};
